/** Whether the App Router's `pathname` is `route`, or with `nested` also a path under it. */
export const onRoute = (pathname: string, route: string, { nested = false } = {}): boolean =>
  pathname === route || (nested && pathname.startsWith(`${route}/`));
